module.exports = __webpack_public_path__ + "img/bold.c230c1d0.svg";